import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'

export class GetAssignedMetricIdsUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    applicationId: string,
    riskType?: string,
  ): Promise<string[]> {
    return this.repository.findAssignedMetricIds(organizationId, applicationId, riskType)
  }
}
